import { render, staticRenderFns } from "./ProducerList.vue?vue&type=template&id=223521ca"
import script from "./ProducerList.vue?vue&type=script&lang=js"
export * from "./ProducerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223521ca')) {
      api.createRecord('223521ca', component.options)
    } else {
      api.reload('223521ca', component.options)
    }
    module.hot.accept("./ProducerList.vue?vue&type=template&id=223521ca", function () {
      api.rerender('223521ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ProducerList.vue"
export default component.exports